import { IPreloadedState } from 'shared/types/redux';

export const selectLocationSwitcherData = (state: IPreloadedState) => state.geo.locationSwitcher;
